<template>
  <b-button 
  @click="$emit('toggle')" 
  size="md" 
  class="bg-transparent border-0 shadow-none">
    <b-icon v-if="mode !== 'dark'"
    icon="moon" 
    aria-hidden="true"
    scale="1.6">
    </b-icon>
    <b-icon v-else
    icon="sun" 
    aria-hidden="true"
    scale="1.6">
    </b-icon>
  </b-button>
</template>

<script>
export default {
  props: ['mode']
}
</script>
